module.exports = __webpack_public_path__ + "media/images/icons/gift-719d976fbc674a0a50e6d249b7af69ad.svg";